import * as React          from 'react';

import { EyeShowVector   } from 'src/components/vector/eye-show';

import { Typography      } from 'src/components/common/typography';

import { Container,
         Icon,
         VStack,
         ReportVariants,
         report_variants } from 'src/components/features/main/shade-selection/report/ui';

import { ColorVariant    } from 'src/providers/theme/shared';



type Props = {
  variant: ReportVariants;
  label: string;
  onAction: (action: 'navigate') => void;
}
export const Report: React.FC<Props> = ({
  variant,
  label,
  onAction,
}) => {
  const lookAndFeel = report_variants.get(variant)!;

  const onContainerTap = () => {
    onAction('navigate');
  }

  return (
    <Container
      lookAndFeel = { lookAndFeel }
      onClick = { (event) => onContainerTap.apply(null, []) }
    >
      <VStack>
        <Typography variant = { 'blackw400s12lh16' } color = { ColorVariant.TEXT_NEUTRAL_TEXT_50 }>
          { "PDF документ" }
        </Typography>
        <Typography variant = { 'blackw400s12lh16' } color = { ColorVariant.TEXT_ACCENT_BLUE_COBALT_100 }>
          { label }
        </Typography>
      </VStack>
      <Icon lookAndFeel = { lookAndFeel }>
        <EyeShowVector />
      </Icon>
    </Container>
  );
};
